
// FOR HOLIDAYS AND WEEKEND MANAGE

import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Button, Box, Typography } from '@mui/material';
import CustomModal from '../../../../Components/custom_components/CustomModal/CustomModal';
import './CalendarView.css';
import { add_holiday, delete_holiday, get_All_holidays, update_holiday } from '../../../../config/SettingsApis/holidayApis';
import { ErrorToast, SuccessToast } from '../../../../utils/toast';
import CustomDeleteConfirmModal from '../../../../Components/custom_components/CustomDeleteConfirmModal/CustomDeleteConfirmModal';
import { hasPrivilege } from '../../../../utils/privileges';
import { useSelector } from 'react-redux';
import HolidaySettings from '../HolidaySettings/HolidaySettings';
import WeekendSettingsModal from '../WeekendSettings/WeekendSettingsModal';
import crossImg from '../../../../Assets/CommonImages/crossImg.png'
import CustomTooltip from '../../../../Components/custom_components/CustomTooltip/CustomTooltip';
import { get_leaveRequest_without_pagination } from '../../../../config/ManagementApis/LeaveRequestApis';
const CalendarView = () => {
    const privileges = useSelector((state) => state.privileges.privileges);

    const [open, setOpen] = useState(false);
    const [events, setEvents] = useState([]); //FOR EVENTS STORE
    const [selectedEvent, setSelectedEvent] = useState(null);
    // const [weekendDays, setWeekendDays] = useState([]); //FOR WEEKEND SHOWING (VALUES LIKE 0 TO 7)
    const [refresh, setRefresh] = useState(false);

    const [isWeekendModalOpen, setIsWeekendModalOpen] = useState(false);
    const [actualWeekendDays, setActualWeekendDays] = useState([]);

    const handleCloseWeekend = () => setIsWeekendModalOpen(false);
    const [currentMonthYear, setCurrentMonthYear] = useState({ year: null, month: null });

    // Map day names to numbers used by FullCalendar (0=Sunday, ..., 6=Saturday)
    const ActualWeekendDayNumbers = actualWeekendDays?.map(day =>
        ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day)
    );

    const renderDayCell = (info) => {
        const dayNum = info.date.getDay(); // 0 = Sunday, ..., 6 = Saturday
        const dayEl = info.el.querySelector('.fc-daygrid-day-number');

        if (ActualWeekendDayNumbers.includes(dayNum)) {

            dayEl?.classList.add('weekend-day-number');
        } else {
            dayEl?.classList.remove('weekend-day-number'); // Optional cleanup
        }
    };

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState({
        isOpen: false,
        id: '',
    });

    useEffect(() => {
        if (currentMonthYear?.year && currentMonthYear?.month && !isWeekendModalOpen) {
            fetchHolidays();
            // fetchEmployeeLeaves()
        }
    }, [refresh, currentMonthYear, isWeekendModalOpen]); //added isWeekendModalOpen for when not update after slect a weekend


    // FOR FETCHING HOLIDAYS
    const fetchHolidays = async () => {

        try {
            const response = await get_All_holidays(currentMonthYear);
            if (response?.status === "success") {

                const { holidays, weekends, Leave_Details } = response.data;

                // Convert holidays to FullCalendar events
                const holidayEvents = holidays?.map(event => ({
                    id: event.HD_Id,
                    title: event.HD_Name,
                    start: moment(event.HD_FromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    end: moment(event.HD_ToDate, 'DD-MM-YYYY').add(1, 'day').format('YYYY-MM-DD'), // FullCalendar excludes end date
                    color: 'rgb(86 124 9)', // Optional: different color for holidays
                }));

                // Convert weekend dates to background events
                const weekendEvents = weekends?.[0]?.Dates?.map((date, idx) => ({
                    id: `weekend-${idx}`,
                    start: date,
                    end: moment(date).add(1, 'day').format('YYYY-MM-DD'),
                    display: 'none',
                    backgroundColor: 'red',
                    type: 'weekend',
                })) || [];
                setActualWeekendDays(weekends?.[0]?.Days || [])
                setEvents([...holidayEvents, ...weekendEvents]);
            }
        } catch (error) {
            setEvents([]);
            console.log(error);
        } finally {
        }
    };

    // FOR DATE CLICK
    const handleDateClick = (arg) => {
        setSelectedEvent({
            title: "",
            startDate: dayjs(arg.date).format("DD-MM-YYYY"),
            endDate: dayjs(arg.date).format("DD-MM-YYYY"), // Default same as start
            // isWeekend: false,
        });
        setOpen(true);
    };
    //FOR EVENT  CLICK
    const handleEventClick = (clickInfo) => {
        const { id, title, start, end, extendedProps } = clickInfo.event;
        setSelectedEvent({
            id,
            title,
            startDate: dayjs(start).format("DD-MM-YYYY"),  // Convert back for form
            endDate: dayjs(end).subtract(1, "day").format("DD-MM-YYYY"), // Adjust end date
        });
        setOpen(true);
    };

    // save event
    const handleSaveEvent = async (newEvent) => {
        const isUpdate = Boolean(newEvent?.id);

        const payload = {
            HD_Name: newEvent?.title || '',
            HD_FromDate: newEvent?.start,
            HD_ToDate: newEvent?.end,
            type: 'holiday',

            ...(isUpdate && { Holidyid: newEvent?.id })
            // Add only if updating
        };

        try {
            const apiFunction = isUpdate ? update_holiday : add_holiday;
            const response = await apiFunction(payload);

            if (response?.status === "success") {
                setRefresh(prev => !prev);
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        }

        setOpen(false); // Close modal
    };

    // save WEEKEND
    const handleSaveWeekend = async () => {
        // Map day names to numbers used by FullCalendar (0=Sunday, ..., 6=Saturday)
        const payload = {
            type: `weekend`,
            WD_Days: ActualWeekendDayNumbers
        }
        try {
            // const apiFunction = !true ? update_holiday : add_holiday;
            const apiFunction = add_holiday;

            const response = await apiFunction(payload);

            if (response?.status === "success") {
                setRefresh(prev => !prev);
                SuccessToast(response?.message);
                handleCloseWeekend(); // Close modal
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        }


    };
    // Function to delete an event
    const handleDeleteEvent = async () => {

        const payload = {
            Holidyid: isDeleteModalOpen?.id,
        };
        try {
            const response = await delete_holiday(payload); // API call to delete the holiday

            if (response?.status === "success") {
                setRefresh(prev => !prev);
                handlDeleteModal(false, '')
                handleClose() //CLOSE THE CALENDER MODAL AFTER DELETED
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        }
    };

    // CLOSE THE CLENDER MODAL
    const handleClose = () => {
        setOpen(false);
    };

    // Handle weekend day selection
    const handleWeekendChange = (newWeekendDays) => {
        setActualWeekendDays(newWeekendDays);
    };

    // Function to handle HIDE/SHOW DELETE MODAL
    const handlDeleteModal = (isOpen, id = '') => {
        setIsDeleteModalOpen({ isOpen, id })
    }

    const PERMISSION_ACTIONS = {
        view: 4,
        edit: 5,
        add: 3,
        delete: 7,
    };

    // Map permissions to boolean values based on privileges
    const userPermissions = {
        view: hasPrivilege(privileges, "Settings", 14, PERMISSION_ACTIONS.view),
        edit: hasPrivilege(privileges, "Settings", 14, PERMISSION_ACTIONS.edit),
        add: hasPrivilege(privileges, "Settings", 14, PERMISSION_ACTIONS.add),
        delete: hasPrivilege(privileges, "Settings", 14, PERMISSION_ACTIONS.delete),

    };

    return (
        <Box p={3}>

            {(userPermissions.add || userPermissions.edit) &&
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button variant="outlined" onClick={() => { setIsWeekendModalOpen(true) }} sx={{ mb: 2 }}>
                        Set Weekend Days
                    </Button>
                </div>
            }
            <FullCalendar
                key={ActualWeekendDayNumbers.join('-')} //forces re-render on weekend change
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                weekends={true}
                events={events}
                dayCellDidMount={renderDayCell}
                eventClick={handleEventClick}  // Capture click event
                // dateClick={handleDateClick}
                dateClick={(info) => {
                    const clickedDate = info.date;
                    const calendarApi = info.view.calendar;
                    const currentViewStart = info.view.currentStart;
                    const currentViewEnd = info.view.currentEnd;

                    // Check if clickedDate is within current month range
                    if (clickedDate >= currentViewStart && clickedDate < currentViewEnd) {
                        const currentMonth = calendarApi.getDate().getMonth();
                        if (clickedDate.getMonth() === currentMonth && (userPermissions.add || userPermissions.edit)) {
                            handleDateClick(info);
                        } else {
                            console.log("Clicked a non-current month date");
                        }
                    }
                }}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: '', //dayGridMonth,timeGridWeek,timeGridDay
                }}

                eventContent={(eventInfo) => (

                    <Box display="flex" justifyContent="space-between" alignItems="center" px={1}>
                        <CustomTooltip title={eventInfo.event.title}>
                            <Typography >
                                {eventInfo.event.title}
                            </Typography>
                        </CustomTooltip>
                        {userPermissions.delete && !eventInfo?.event?.extendedProps?.type &&  //WEEKED TRUE ONLY SHOW THE LABEL
                            <img onClick={(e) => { e.stopPropagation(); handlDeleteModal(true, eventInfo.event.id) }} src={crossImg} alt="close" className='close-icon' />}
                    </Box>
                )}
                // showNonCurrentDates={false} /// hide the dates that do not belong to the current month.

                firstDay={0}                // start week on Monday
                fixedWeekCount={true}       // always show 6 weeks
                showNonCurrentDates={true}  // show extra days from other months 

                height="auto"
                datesSet={(arg) => {
                    const calendarDate = moment(arg.start).add(15, 'days'); // middle of the current view
                    const month = calendarDate.month() + 1; // 0-based, so add 1
                    const year = calendarDate.year();
                    setCurrentMonthYear({ month, year });
                }}
            />
            {open && <CustomModal
                open={open}
                handleClose={handleClose}
                title={"Holiday Settings"}
                maxWidth="700px"
                body={
                    <HolidaySettings
                        selectedEvent={selectedEvent}
                        handleSaveEvent={handleSaveEvent}
                        handleDeleteEvent={handleDeleteEvent}
                    />
                }
            />}


            {isWeekendModalOpen && <CustomModal
                open={isWeekendModalOpen}
                handleClose={handleCloseWeekend}
                title={"Weekend Settings"}
                maxWidth="700px"
                body={
                    <WeekendSettingsModal
                        onClose={handleCloseWeekend}
                        selectedDays={actualWeekendDays}
                        handleWeekendChange={handleWeekendChange}
                        handleSaveWeekend={handleSaveWeekend}
                    />
                }
            />}


            {/* Holiday Delete Modal */}
            {isDeleteModalOpen?.isOpen && <CustomDeleteConfirmModal
                module_name={'Holiday'}
                open_modal={isDeleteModalOpen?.isOpen}
                close_modal={handlDeleteModal}
                confirm_function={handleDeleteEvent}
            />
            }

        </Box>
    );
};

export default CalendarView;
